export default __webpack_public_path__ + "static/media/corporate3.0135842d.png";